export const reviewsWithSuppliers = `
  query ReviewsWithSuppliers {
    reviewsWithSuppliers {
      supplierKrn
      review {
        id
        hdlId
        url
        name
        type
        isOrganisation
        addresses {
          address
          city
          country
          state
          zipcode
        }
        websites
        location {
          latitude
          longitude
        }
        score
        nrOfRatings
        statistics {
          year
          ratingScore
          ratingCount
        }
        lastRatings {
          date
          questions {
            key
            value {
              score
              label
              description
            }
          }
          score
          disease {
            id
            value
          }
          comment
          url
          sourceType
        }
        registrationNumber
        locationNumber
        nickname
        brandName1
        brandName2
      }
    }
  }
`;
